import { IRoute } from "../../../common/helpers/routesMapper";
import injectIntl from "../../../common/helpers/injectIntl";
import { connect } from "react-redux";
import getPlan from "../../store/plan/actions/getPlan";
import { seo } from "../../../common/helpers/seo";

import ChristmasTuning from "./ChristmasTuning";
import { seoImageUrl } from "./utils";

export default {
    component: connect(null, { getPlan })(injectIntl(ChristmasTuning)),
    renderSeo: (store, allMessage, lang) => {
        return seo({
            title: allMessage["christmas.title"],
            description: allMessage["christmas.seo"],
            image: seoImageUrl,
            allMessage,
            lang,
        });
    },
} satisfies IRoute;
